module.exports = __webpack_public_path__ + "static/2_icon-f64736bf045c8557aca2764eaf4d8316.svg";